<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Benefits</div>
                <button type="button" v-on:click.prevent="addBenefit" class="btn btn-primary">Add</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="app-filter-good-table-container">
                    <vue-good-table
                        ref="benefitList"
                        mode="remote"
                        @on-page-change="onPageChange"
                        @on-selected-rows-change="selectionChanged"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: serverParams.perPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                        }"
                        :selectOptions="{
                        enabled: true,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                        }"
                        :search-options="{
                        enabled: false,
                        }" >


                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <!--class="btn btn-xs btn-primary"-->
                                <div v-if="props.column.field == 'action'" >
                                    <router-link title='Edit Benefit' class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'UpdateBenifit',params:{id:props.row.id}}"><i class="fa fa-pencil" aria-hidden="true"></i></router-link>
                                    <a title='Delete Benefit' id="delete" class="btn edit-btn-vvg waves-effect"  v-on:click.prevent="deleteBenefit(props.row.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                                    <template v-if="props.row.status">
                                        <a title='Make Inactive' id="status" class="btn edit-btn-vvg waves-effect"  v-on:click.prevent="activeInactiveBenefit(props.row.id, 'inactive')"><i class="fa fa-eye-slash" aria-hidden="true"></i></a>
                                    </template>
                                    <template v-else>
                                        <a title='Make Active' id="status" class="btn edit-btn-vvg waves-effect"  v-on:click.prevent="activeInactiveBenefit(props.row.id, 'active')"><i class="fa fa-eye" aria-hidden="true"></i></a>
                                    </template>
                                    <!--<button title='Delete Benefit' id="delete" class="btn edit-btn-vvg"  v-on:click.prevent="deleteBenefit(props.row.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>-->
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>

                        <div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                            <button id="deleteMultiple" class="btn btn-primary" v-on:click.prevent="activeInactiveBenefit(0, 'active')">Active Benefit({{selectedRows}})</button>
                            <button id="deleteMultiple" class="btn btn-primary" v-on:click.prevent="activeInactiveBenefit(0, 'inactive')">Inactive Benefit({{selectedRows}})</button>
                            <button id="deleteMultiple" class="btn btn-primary" v-on:click.prevent="deleteBenefit(0)">Delete Benefit({{selectedRows}})</button>
                        </div>
                    </vue-good-table>
                </div>
            </div>
        </div>
        <!--page content-->
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';

    var self;
    export default {
        name: 'ListBenefits',
        components: {
            'app-backend-footer': BackendFooter,
        },
        mixins: [SessioMixin],
        data() {
            return {
                firstLoad: 0,
                columns: [
                    /*{
                     label: 'ID',
                     field: 'id',
                     filterable: true,
                     filterOptions: {
                     enabled: true, // enable filter for this column
                     placeholder: "ID", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     filterDropdownItems: [], // dropdown (with selected values) instead of text input
                     filterFn: this.onColumnFilter, //custom filter function that
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },*/
                    {
                        label: 'State',
                        field: 'location_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "State", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Location Type',
                        field: 'location_type',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location Type", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, {
                        label: 'URL',
                        field: 'url',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "URL", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Group',
                        field: 'group',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Group", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, {
                        label: 'Provider Name',
                        field: 'provider_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Provider Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Type Name',
                        field: 'type_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Type Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated By',
                        field: 'updated_by',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Updated By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '150px',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'asc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
            }

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            //self.checkLogin();
        },
        mounted: function () {
//            self = this;
            self.showLoader();
            self.loadBenefit();
            self.loadLocationsAdd();
            if ($('#li_benefit').children().eq(0).children().eq(1).attr('class').indexOf('fa-angle-down') != -1) {
                $('#li_benefit').children().eq(0).children().eq(1).addClass('fa-angle-up');
                $('#li_benefit').children().eq(0).children().eq(1).removeClass('fa-angle-down');
            } else {
                $('#li_benefit').children().eq(0).children().eq(1).removeClass('fa-angle-up');
                $('#li_benefit').children().eq(0).children().eq(1).addClass('fa-angle-down');
            }
        },
        methods: {
            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            self.locationArr = [];
                            /*self.locationArr = response.data.content;*/
                            $.each(response.data.content, function (i) {
                                self.locationArr.push(response.data.content[i].text);
                            });
                            /*$.each(response.data.content, function (i) {
                             if (response.data.content[i].value == 0) {
                             self.locationArr.push(response.data.content[i]);
                             }
                             });
                             $.each(response.data.content, function (i) {
                             if (response.data.content[i].value != 0) {
                             self.locationArr.push(response.data.content[i]);
                             }
                             });*/
                            $.each(self.columns, function (i) {
                                if (self.columns[i].field == 'location_name') {
                                    self.columns[i].filterOptions.filterDropdownItems = self.locationArr;
                                }
                            });
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            addBenefit() {
                self.$router.push('/backend/addbenefits/');
            },

            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            //
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadBenefit();
            },
            //
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadBenefit();
                }
            },

            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('location_name');
                    field: ('location_type');
                    field: ('url');
                    field: ('group');
                    field: ('provider_name');
                    field: ('type_name');
                    field: ('updated_by');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.id || filters.location_name || filters.location_type || filters.url || filters.group || filters.provider_name || filters.type_name || filters.updated_by) {
                    self.loadBenefit();
                }

            },
            selectionChanged() {
                var self = this;
                self.selectedRows = (self.$refs['benefitList'].selectedRows).length;
                /*console.log(self.selectedRows);*/
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadBenefit();
            },

            deleteBenefit: function (id) {
                var selectedUser = self.$refs['benefitList'].selectedRows;
                var deleteIdArr = [];
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                if(id != 0) {
                    deleteIdArr.push(id);
                } else {
                    for (var i = 0; i < selectedUser.length; i++) {
                        deleteIdArr.push(this.$refs['benefitList'].selectedRows[i].id);
                    }
                }
                var fields = {
                    deleteIdArr: deleteIdArr,
                }

                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post("deletebenefit", fields, config)
                                .then(function (response) {
                                    self.loadBenefit();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal('Deleted', 'You successfully deleted benefit(s)', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your file is still intact', 'info')
                    }
                })
            },

            loadBenefit: function () {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    messageData: self.message,
                    sort: self.serverParams.sort
                };
                self.showLoader();
                HTTP.post('listbenefit', fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;

                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            //console.log("status : " + err.response.status);
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            activeInactiveBenefit: function(id, status) {
                var selectedActiveInactive = self.$refs['benefitList'].selectedRows;
                var activeInactiveArr = [];
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                if(id != 0) {
                    activeInactiveArr.push(id);
                } else {
                    for (var i = 0; i < selectedActiveInactive.length; i++) {
                        activeInactiveArr.push(this.$refs['benefitList'].selectedRows[i].id);
                    }
                }
                var fields = {
                    activeInactiveArr: activeInactiveArr,
                    status: status,
                }
                this.$swal({
                    title: '',
                    text: 'Are you sure you want to ' + status + ' this Benefit(s)!',
                    type: 'info',
                    confirmButtonText: 'OK',
                    showCancelButton: true,
                    // showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post("activeinactivebenefit", fields, config)
                                .then(function (response) {
                                    self.loadBenefit();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal('Success', 'You successfully ' + status + ' benefit(s)', 'success')
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/benefits/ListBenefits.vue